import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import countryPhoneCodes from '../../../../shared/countryPhoneCodes.json'

const SubmitPhoneForm = props => {
  const { error, countryCode, handleSubmit } = props

  return (
    <form onSubmit={handleSubmit} method="post" aria-labelledby="phone-form-title">
      <div id="phone-form-title" className="sr-only">
        Phone verification form
      </div>
      <div>
        <div className="sr-only">Mobile phone verification</div>
        <div className="row">
          <Field
            component={renderField}
            type="tel"
            name="phone"
            containerclass="col-md-12"
            label="global.label.mobilePhone"
            inputType="input"
            prepend={countryPhoneCodes[countryCode]}
            aria-describedby="phone-format-help"
          />
          <div id="phone-format-help" className="sr-only">
            Enter your mobile phone number. Country code {countryPhoneCodes[countryCode]} will be
            added automatically.
          </div>
        </div>
        {error && (
          <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
            <FormattedMessage id={error} />
          </div>
        )}
        <br />
        <Button
          name="submitPhoneFormSubmitBtn"
          type="submit"
          outline
          color="dark"
          block
          aria-describedby={error ? 'phone-form-error' : undefined}
        >
          <FormattedMessage id="global.label.verifyPhone" />
        </Button>
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'SubmitPhoneForm',
})(SubmitPhoneForm)
